export const buttonGroupActiveFix = () => {
    $('.btn-group .btn').on('click', function() {
        $(this).siblings().removeClass('focused-btn');
    });
};
